import { DataFlowMapColumn } from 'app/model/dataflow/dataflow-map.column';
import { IMapColumn } from './IMapColumn';
import { BooleanDataFlowType, StringDataFlowType } from './dataflow-datatype';
import { dataFlowPatternParameter } from './dataflow-expression-utilities';
import { BaseColumnMappingTransformation } from './base-column-mapping-transformation';
import { Owned } from '../base/named';
import { DataFlowTypesUtils } from './dataflow-type-utilities';

import { ComplexTypeUtils } from 'app/authoring/component/transformations/complex-type-utils';
import { DataFlowExpressionBasedMapColumn } from './dataflow-expression-based-map.column';

export interface IColumnMappingTransformation {
    schema: IMapColumn[];
    updateColumnInformation(): void;
}

export class ColumnMappingTransformationUtils {
    public static readonly matchAllColumnsTemplateExpression = `/* ${stringResources.AllInputColumnsComment} */ true()`;
    public static readonly byNameDataFlowExpression = `/* ${stringResources.InputNameComment} */ ${dataFlowPatternParameter}`;
    public static readonly useRuleBasedMappingAsDefaultThreshold = 50;

    public static updateColumnMapping(transformation: BaseColumnMappingTransformation): void {
        const availableColumnRefs = transformation.distinctInputColumnRefs;
        transformation.schema.forEach((mapping) => {
            if (mapping instanceof DataFlowMapColumn && mapping.columnRef) {
                // looking on root name as we don't want to search with the full field path
                const availableColumn = availableColumnRefs.find((columnRef) => columnRef.name === mapping.columnRef.rootColumnName);
                const columnRef = availableColumn || mapping.columnRef;
                if (mapping.columnRef.complexFieldPath && availableColumn && availableColumn.column) {
                    mapping.columnRef.column = columnRef.column;
                    mapping.dataFlowColumnType = ComplexTypeUtils.getFieldDataType(availableColumn.column, mapping.columnRef.complexFieldPath);
                } else {
                    mapping.columnRef = columnRef;
                    if (availableColumn && availableColumn.column) {
                        mapping.columnType = availableColumn.column.columnType;
                    }
                }
            }
        });
    }

    public static shouldDefaultToRuleBasedMapping(transformation: BaseColumnMappingTransformation): boolean {
        return transformation.distinctInputColumnRefs.length > ColumnMappingTransformationUtils.useRuleBasedMappingAsDefaultThreshold;
    }

    public static createMatchAllColumnsRuleBasedMapping(entity: BaseColumnMappingTransformation): DataFlowExpressionBasedMapColumn {
        const matchAllMapping = Owned.create<DataFlowExpressionBasedMapColumn>(DataFlowExpressionBasedMapColumn.MODEL, entity);
        matchAllMapping.writeColumn = true;
        matchAllMapping.templateCondition.expression = ColumnMappingTransformationUtils.matchAllColumnsTemplateExpression;
        matchAllMapping.templateCondition.returnType = DataFlowTypesUtils.createType(BooleanDataFlowType.TYPE);
        matchAllMapping.dataFlowExpression.expression = ColumnMappingTransformationUtils.byNameDataFlowExpression;
        matchAllMapping.dataFlowExpression.returnType = DataFlowTypesUtils.createType(StringDataFlowType.TYPE);
        return matchAllMapping;
    }
}
